import { provideBootstrapEffects } from '@innogy/utils-state';

import { OrderAddressEffects } from './address';
import { OrderConfirmationEffects } from './confirmation';
import { OrderErrorEffects } from './order-error.effects';
import { OrderFormSubmitEffects } from './order-form-submit.effects';
import { OrderTrackingEffects } from './order-tracking.effects';
import { OrderPaymentEffects } from './payment';
import { OrderCrossSellEffects } from './cross-sell';
import { OrderCustomerTypeEffects } from './customer-type';

export * from './address';
export * from './confirmation';
export * from './payment';
export * from './personal';
export * from './cross-sell';
export * from './customer-type';

export * from './order.state';
export * from './order.actions';
export * from './order.selector';

export const orderEffects = [
  OrderErrorEffects,
  OrderTrackingEffects,
  OrderConfirmationEffects,
  OrderPaymentEffects,
  OrderCrossSellEffects,
  OrderCustomerTypeEffects,
];

export const orderProviders = [
  provideBootstrapEffects([OrderFormSubmitEffects, OrderAddressEffects]),
];
